import * as React from 'react';
import classNames from 'classnames';
import { EGlyphicon } from 'source/app/presentation/Shared/Glyphicon/EGlyphicon';

const Glyphicon = ({
	icon,
	withClass,
	tooltip
}: {
	icon: EGlyphicon;
	withClass?: string;
	tooltip?: string
}) => (
	<span
		className={classNames(
			'glyphicon',
			'glyphicon-' + EGlyphicon[icon],
			withClass
		)}
		data-tip={tooltip}
	/>
);

export default Glyphicon;


